import { DURATION_LABEL_KEYS } from "../constants/layout";
import { DURATION_MATCHING, DURATION_MATCHING_REVERSE } from "../constants/product";
import { OptionToSelectOpt, ProductForProductPageType } from "../types/ProductPage";

export const getOptionFirstlabel = (product: ProductForProductPageType, option: OptionToSelectOpt & { attribute_code: string }, span: string, i18n, $fc) => {
  
  let variant = product.variants.find(el => {
    const varValue = el.product[option.attribute_code].value ?? el.product[option.attribute_code]
    return varValue== option.value_index
    && (option.attribute_code == 'tipo_abbonamento' || DURATION_MATCHING[el.product.tipo_abbonamento] == span)
  }).product;
  
  const variantFullPrice = variant.full_price&&variant.full_price>0 ?variant.full_price: variant.price_range.maximum_price.final_price.value
  let promotionalDuration = product.promotional[span] && product.promotional[span].duration ? product.promotional[span].duration : DURATION_MATCHING_REVERSE[span]

  /**questo pezzo serve a coprire errori in configurazione che sono stati gestiti da codice. MALE MALE. */
  if (span == 'Y' && promotionalDuration == 12) {
    promotionalDuration = 1 /** riportiamo al singolare */
  }

  span = span ? span : product.trialDurationSpan;
  const isCurrentPlanTrial = product.isTrial && (product.trialDurationSpan == span || !product.paymentFrequencies.includes(product.trialDurationSpan));
  //const i18n = useI18n(); error on getting vue instance @TODO check why
  /**  TRIAL */
  if (isCurrentPlanTrial) {
    return i18n.tc("{durationQty} {duration} of trial at {trialPrice}", product.trialPrice, {
      durationQty: product.trialDuration,
      duration: i18n.tc(DURATION_LABEL_KEYS[product.trialDurationSpan], product.trialDuration),
      trialPrice: $fc(product.trialPrice /*+ $shippingPrice*/)
    }) as String;
  } else if (variant.promotional_price) {
    /** PROMOTIONAL */
    if (variant.promotional_price <variantFullPrice) {
      return i18n.t("{durationQty} {duration} at {price} {discountedPrice}", {
        durationQty: promotionalDuration,
        duration: i18n.tc(DURATION_LABEL_KEYS[span], promotionalDuration),
        price: $fc(variantFullPrice /*+ $shippingPrice*/),
        discountedPrice: $fc(variant.promotional_price /*+ $shippingPrice*/)
      }) as String
    } else if (variant.startup_cost) {
      console.log('LABEL 3')
      return i18n.t("{price} first {duration}(included {startup})", {
        price: $fc(variant.promotional_price /*+ $shippingPrice*/),
        duration: i18n.tc(DURATION_LABEL_KEYS[span], promotionalDuration),
        startup: $fc(variant.startup_cost)
      })
    } else {
      console.log('LABEL 4')
      return i18n.t("{durationQty} {duration} at {discountedPrice}", {
        durationQty: promotionalDuration,
        duration: i18n.tc(DURATION_LABEL_KEYS[span], promotionalDuration),
        discountedPrice: $fc(variant.promotional_price /*+ $shippingPrice*/)
      }) as String
    }
  } else if (variant.discounted_price) {
    /**  DISCOUNTED */
    console.log('LABEL DISCOUNTED')
    const label = i18n.tc("discounted {price} {discountedPrice} each {durationQty} {duration}", 1, {
      price: $fc(variantFullPrice /*+ $shippingPrice*/),
      discountedPrice: $fc(variant.discounted_price /*+ $shippingPrice*/),
      durationQty: 1,
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1),
    }) as String
    return label
  } else {
    /** STANDARD */
    return i18n.tc("{price} / each {durationQty} {duration}", 1, {
      price: $fc(variantFullPrice /*+ $shippingPrice*/),
      durationQty: 1,
      duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
    }) as String;

  }


}


export const getOptionSecondlabel = (product: ProductForProductPageType, option: OptionToSelectOpt & { attribute_code: string }, span: string, i18n, $fc) => {
  const variant = product.variants.find(el => {
    const varValue = el.product[option.attribute_code].value ?? el.product[option.attribute_code]
    return varValue == option.value_index
    && (option.attribute_code == 'tipo_abbonamento' || DURATION_MATCHING[el.product.tipo_abbonamento] == span)
  }).product;
  const variantFullPrice = variant.full_price&&variant.full_price>0 ?variant.full_price: variant.price_range.maximum_price.final_price.value
  span = span ? span : product.trialDurationSpan;
  const isCurrentPlanTrial = product.isTrial && (product.trialDurationSpan == span || !product.paymentFrequencies.includes(product.trialDurationSpan));
  
  let promotionalDuration = product.promotional[span] && product.promotional[span].duration ? product.promotional[span].duration : DURATION_MATCHING_REVERSE[span]
  /**questo pezzo serve a coprire errori in configurazione che sono stati gestiti da codice. MALE MALE. */
  if (span == 'Y' && promotionalDuration == 12) {
    promotionalDuration = 1 /** riportiamo al singolare */
  }

  if(isCurrentPlanTrial || variant.promotional_price){
    if (variant.promotional_price) {
      const promotionalString = i18n.tc("{price} / trial {durationQty} {duration}", promotionalDuration, {
        price: $fc(variant.promotional_price /*+ $shippingPrice*/),
        durationQty: promotionalDuration,
        duration: i18n.tc(DURATION_LABEL_KEYS[span], promotionalDuration),
      });
      const priceString = variant.discounted_price ? 
        i18n.tc("discounted {price} {discountedPrice} each {durationQty} {duration}", 1,  {
          price: $fc(variantFullPrice /*+ $shippingPrice*/),
          discountedPrice: $fc(variant.discounted_price /*+ $shippingPrice*/),
          durationQty: 1, duration: i18n.tc(DURATION_LABEL_KEYS[span], 1),
        }) as String
        : i18n.tc("{price} / each {durationQty} {duration}", 1, {
          price: $fc(variantFullPrice /*+ $shippingPrice*/),
          durationQty:1,  duration: i18n.tc(DURATION_LABEL_KEYS[span], 1),
        }) as String
      return i18n.t("then {promotionalString} and then {priceString}", {promotionalString, priceString}) as String
    } else if (variant.discounted_price) {
            return i18n.tc("then {price} {discountedPrice} / {durationQty} {duration}",1,{
                price: $fc(variantFullPrice /*+ $shippingPrice*/),
                discountedPrice : $fc(variant.discounted_price /*+ $shippingPrice*/),
                duration: i18n.tc(DURATION_LABEL_KEYS[span], 1),
                durationQty: 1
            }) as String;
        }else{
            return i18n.t("then {price} / {duration}",{
                price: $fc(variantFullPrice /*+ $shippingPrice*/),
                duration: i18n.tc(DURATION_LABEL_KEYS[span], 1)
            }) as String;
        }
  }
  return null;
}